import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface PaymentMethodOptionProps {
  icon: ReactNode;
  label: string;
  fee: string;
}

export const PaymentMethodOption = ({
  icon,
  label,
  fee,
}: PaymentMethodOptionProps) => {
  const [t] = useTranslation("global");

  if (!label)
    return (
      <div className="w-full flex items-center gap-2 py-1 px-1 cursor-pointer">
        <p className="text-sm font-normal text-gray-500 pl-1">
          {t("Quoter.PaymentMethod.Placeholder")}
        </p>
      </div>
    );

  return (
    <div className="w-full flex items-center gap-2 py-1 px-1 cursor-pointer">
      {icon}
      <div className="flex flex-col flex-1 gap-[1px]">
        <div className="flex flex-wrap gap-x-1 items-center">
          <p className="text-[13px] xs:text-sm font-medium text-black break-words max-w-full">
            {t(`Quoter.PaymentMethod.${label}`)}
          </p>
          <p className="text-sm font-medium text-gray-400">•</p>
          <p className="text-xs font-medium text-gray-400">
            {t(`Quoter.PaymentMethodFee`)} {fee || ""} USD
          </p>
        </div>
        <p className="w-fit bg-[#3D73F31A] text-primary-600 font-medium rounded-full py-1 px-3 text-xs">
          {t(`Quoter.Time.${label}`)}
        </p>
      </div>
    </div>
  );
};
